<template>
	<div class="checkweight_order" id="checkweight_order" :style="{ height: `${windowHeight}px`, 'overflow-y': 'scroll' }">
		<el-form>
			<el-card>
				<el-row class="formTitle">
					<!-- <el-col :span="2">
						<span style="color: transparent;">1</span>
					</el-col> -->
					<el-col :span="8">
						<label for>
							<el-checkbox v-model="remind" :true-label="1" :false-label="0"></el-checkbox>
							<span v-if="remind==0">{{checkweight_lang.manualconfirm}}</span>
						</label>
						<span v-if="remind==1">{{checkweight_lang.when}}{{checkweight_lang.weightdiff}}{{checkweight_lang.more}}</span>
							<el-input type="text" v-model="diffweight" v-if="remind==1" style="width:80px;margin-left:5px;font-size:15pt">
							</el-input>
						<span v-if="remind==1">{{checkweight_lang.manualconfirm}}</span>
					</el-col>
				</el-row>
				<table style="width:99%">
					<tr>
						<td valign="top">
							<div class="formContent">
								<table class="htmltable">
									<tr>
										<td class="tdleft"><span>{{checkweight_lang.batchno}}</span></td>
										<td colspan="3">
											<el-input ref="handlebatch" @keyup.enter.native="EnterEvent('handlebatch')" v-model="form.batch" @blur="SaveBatch"></el-input>
										</td>
									</tr>
									<tr v-for="c in trorder" v-if="c.isshow == 1">
										<td class="tdleft_bold">
											<span>
												<b>{{ c.lable }}</b>
											</span>
										</td>
										<td colspan="3" class="b_font">
											<el-input v-model="form.p_pkval" :ref="c.control" @keyup.enter.native="EnterEvent(c.control)" v-if="c.control == 'pkval'"></el-input>
											<el-input
												v-model="form.subpkval"
												:ref="c.control"
												@keyup.enter.native="EnterEvent(c.control)"
												v-if="c.control == 'subpkval'"
											></el-input>
											<el-input v-model="form.grossweight" :ref="c.control" @keyup.enter.native="EnterEvent(c.control)" v-if="c.control == 'weight'"></el-input>
										</td>
									</tr>
									<tr>
										<td class="tdleft_bold"><span>{{checkweight_lang.volume}}</span></td>
										<td colspan="3" style="text-align:left;">
											<div style="display:inline;margin-left:10px">
												<span> {{checkweight_lang.length}}
													<el-input type="text" style="width:70px" ref="p_length" v-model="form.p_length" @keyup.enter.native="EnterEvent('p_length')"></el-input>
												</span>
												<span> {{checkweight_lang.width}}
													<el-input type="text" style="width:70px" ref="p_width" v-model="form.p_width" @keyup.enter.native="EnterEvent('p_width')"></el-input>
												</span>
												<span> {{checkweight_lang.height}}
													<el-input type="text" style="width:70px" ref="p_height" v-model="form.p_height" @keyup.enter.native="EnterEvent('p_height')"></el-input>
												</span>
											</div>
										</td>
									</tr>
								</table>
							</div>
						</td>
						<td valign="top" rowspan="2">
							<div class="formRight">
								<div class="perpkval">
									<span v-if="form.perpkval != ''">{{checkweight_lang.lastorder}} : {{ perpkval }}</span>
								</div>
							</div>
							<div class="formCargo" v-if="issub">
								<label>
									<i class="el-icon-d-arrow-right"></i>
									{{checkweight_lang.suborder}} 
								</label>
								<tableui style="width:100%;" editcell="0" :tableData="suborder" :columns="ordercolumns"></tableui>
							</div>
						</td>
					</tr>
					<tr>
						<td style="width:50%;">
							<div class="formCargo">
								<i class="el-icon-d-arrow-right"></i>
								<label>
									{{checkweight_lang.scanedorder}}
									<span class="ordercount">{{ scanordercount }}</span>
									{{checkweight_lang.orders}}
								</label>
								<label>
									{{checkweight_lang.scanorderweight}}
									<span class="orderweight">{{ scanorderweight }}</span>
								</label>
							</div>
							<tableui
								style="width:99%;"
								ref="checkweight"
								:tableData="orderTable"
								:columns="scanordercolumns"
							></tableui>
						</td>
					</tr>
				</table>
			</el-card>
		</el-form>
		<errorwin ref="errorwin" @closeerrorwin="closeerrorwin"></errorwin>
		<errorwinbtn ref="errorwinbtn" @errorwincallback="errorwincallback"></errorwinbtn>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
import errorwin from '@/components/order/errorwin.vue';
import errorwinbtn from '@/components/tools/errorwinbtn.vue';
export default {
	name:'checkweight_order',
	components: {
		tableui,
		errorwin,
		errorwinbtn
	},
	props: {
		
	},
	data() {
		return {
			remind:0,
			batch:'',
			diffweight:'',
			trorder: [{ lable: '单 号', control: 'pkval', isshow: 1 }, { lable: '子单号', control: 'subpkval', isshow: 0 }, { lable: '重 量', control: 'weight', isshow: 1 }],
			ordercolumns: [
				{ field: 'p_pkval', title: '单号', type: 'text', width: '150', sortable: false },
				{ field: 'cgprovince', title: '地区', type: 'text', width: '120', sortable: false },
				{ field: 'grossweight', title: '重量', type: 'text', width: '60', sortable: false },
				{ field: 'p_length', title: '长', type: 'text', width: '60', sortable: false },
				{ field: 'p_width', title: '宽', type: 'text', width: '60', sortable: false },
				{ field: 'p_height', title: '高', type: 'text', width: '60', sortable: false }
			],
			scanordercolumns: [
				{ field: 'p_pkval', title: '单号', type: 'text', width: '150', sortable: false },
				{ field: 'cgprovince', title: '地区', type: 'text', width: '120', sortable: false },
				{ field: 'grossweight', title: '重量', type: 'text', width: '60', sortable: false },
			],
			suborder: [],
			suborderscaned:[],//已扫描子单
			subscanfilish: false, //子单是否扫描完成
			perpkval:'',
			form:{
				p_pkval:'',
				grossweight:'',
				p_length:'',
				p_width:'',
				p_height:'',
				amount:0,
				perpay:0,
				batch:'',
				vipaccount:'',
				cgprovince:'',
				subpkval:'',
				u_userid:'',
				p_mode:'',
				factpkval:''
			},
			orderTable: [],
			windowHeight: (window.innerHeight * 88) / 100,
			checkweight_lang:{},
			scanordercount:0,
			scanorderweight:0,
			scanorderamount:0,
			currentcoltrol:'',
			issub:false,
			divclass:'checkweight_order',
			fun:'入库',
			isin:1
		};
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/wm/checkweight_order.scss');
		this.init();
	},
	methods:{
		init(){
			var that=this;
			//debugger
			this.LoadStoragePrintPage();
			this.$public.GetLanguageByMode('checkweight',this).then(res=>{
				//debugger
				if(res.state=='1'){
					that.checkweight_lang=that.$lang.label.checkweight;
					
					that.trorder=[
						{ lable:that.checkweight_lang.orderno, control: 'pkval', isshow: 1 }, 
						{ lable:that.checkweight_lang.suborderno, control: 'subpkval', isshow: 0 }, 
						{ lable:that.checkweight_lang.weight, control: 'weight', isshow: 1 },
					];
					that.ordercolumns=[
						{ field: 'p_pkval', title:that.checkweight_lang.orderno, type: 'text', width: '150', sortable: false },
						{ field: 'cgprovince',title:that.checkweight_lang.area, type: 'text', width: '120', sortable: false },
						{ field: 'grossweight', title:that.checkweight_lang.weight, type: 'text', width: '60', sortable: false },
						{ field: 'p_length', title:that.checkweight_lang.length, type: 'text', width: '60', sortable: false },
						{ field: 'p_width', title:that.checkweight_lang.width, type: 'text', width: '60', sortable: false },
						{ field: 'p_height', title: that.checkweight_lang.height, type: 'text', width: '60', sortable: false }
					];
					that.scanordercolumns=[
						{ field: 'p_pkval', title:that.checkweight_lang.orderno, type: 'text', width: '150', sortable: false },
						{ field: 'cgprovince', title:that.checkweight_lang.area, type: 'text', width: '120', sortable: false },
						{ field: 'grossweight', title:that.checkweight_lang.weight, type: 'text', width: '60', sortable: false },
					]
				}
			});
			var that=this;
			this.$nextTick(function(e){
				that.$refs.pkval[0].focus();
			});
		},
		LoadStoragePrintPage() {
			var that = this;
			var paraminfo = {
				isin: this.isin,
				userid: localStorage.getItem('userid')
			};
			this.$apipost.get.LoadStoragePrintPage({ paraminfo: paraminfo }).then(res => {
				//debugger
				if (res != '') {
					if(res.handbatch!=undefined)
					{
						that.form.batch = res.handbatch;
						if(that.form.batch!='')
							that.GetOrderlist();
					}
				}
				if(that.form.batch=='')
					that.form.batch=new Date().getTime();
			}).catch(e=>{
				that.LoadStoragePrintPage();
			});
		},
		EnterEvent(control){
			//
			this.currentcoltrol=control;
			if(control=='handlebatch'){
				this.$refs.pkval[0].focus();
			}
			else if(control=='pkval'){
				//获取订单信息
				this.form.p_pkval=this.form.p_pkval.trim();
				this.CheckOrder();
			}
			else if(control=='subpkval'){
				this.form.subpkval=this.form.subpkval.trim();
				this.SetSubMark(this.form.subpkval);
			}
			else if(control=='weight')
			{
				this.form.grossweight=this.form.grossweight.toString().trim();
				if(this.form.grossweight!=''){
					if(!isNaN(parseFloat(this.form.grossweight))){
						this.$refs.p_length.focus();
						this.$refs.p_length.select();
					}
				}
				
			}
			else if(control=='p_length')
			{
				this.form.p_length=this.form.p_length.toString().trim();
				if(this.form.p_length!=''){
					if(!isNaN(parseFloat(this.form.p_length))){
						this.$refs.p_width.focus();
						this.$refs.p_width.select();
					}
				}
			}
			else if(control=='p_width')
			{
				this.form.p_width=this.form.p_width.toString().trim();
				if(this.form.p_width!=''){
					if(!isNaN(parseFloat(this.form.p_width))){
						this.$refs.p_height.focus();
						this.$refs.p_height.select();
					}
				}
			}
			else if(control=='p_height')
			{
				this.form.p_height=this.form.p_height.toString().trim();
				if(this.form.p_width!=''){
					if(!isNaN(parseFloat(this.form.p_width))){
						this.SetSubMark(this.form.factpkval);
					}
				}
			}
		},
		CheckOrder(){
			var that = this;
			if(this.form.p_pkval=='')
				return false;
			this.$apipost.get.CheckOrder({pkval:this.form.p_pkval}).then(res => {
				if (res.state == '1') {
					if(res.list!=undefined){
						that.suborder=res.list;
						//debugger
						if(res.list.length>1)
						{
							that.trorder[1].isshow='1';
							that.issub=true;
							this.$nextTick(function(e){
								that.$refs.subpkval[0].focus();
							});
							this.$tool.ReadMsg(checkweight_lang.suborderempty);
						}
						else{
							//debugger
							this.form.factpkval=res.list[0].p_pkval;
							this.form.p_height=res.list[0].p_height;
							this.form.p_width=res.list[0].p_width;
							this.form.p_length=res.list[0].p_length;
							//this.form.grossweight=res.list[0].grossweight;
							that.$refs.weight[0].focus();
						}
						this.form.vipaccount=res.list[0].vipaccount;
						this.form.perpay=res.list[0].perpay;
						this.form.cgprovince=res.list[0].cgprovince;
						this.form.u_userid=res.list[0].u_userid;
						this.form.p_mode=res.list[0].p_mode;
					}
				}
				else
					that.$refs.errorwin.init({errormsg:res.message,isread:true,focuscontrol:that.currentcoltrol});
			});
		},
		//设置子单标记
		SetSubMark(subpkval) {
			var that = this;
			var suborder = this.suborder;
			var list=this.suborder.filter(function(e){
				return e.p_pkval.toLowerCase() == subpkval.toLowerCase();
			});
			var scanlist=this.suborderscaned.filter(function(e){
				return e.p_pkval.toLowerCase() == subpkval.toLowerCase();
			});
			if(scanlist.length>0)
				this.$refs.errorwin.init({errormsg:subpkval+that.checkweight_lang.repeatscaned,isread:true,focuscontrol:this.currentcoltrol});
			else{
				if(list.length>0){
					if(this.form.grossweight!='')
					{
						for (var i = 0; i < suborder.length; i++) {
							if (suborder[i].p_pkval.toLowerCase() == subpkval.toLowerCase()) {			
								suborder[i].cgprovince=this.form.cgprovince;
								suborder[i].vipaccount=this.form.vipaccount;
								suborder[i].p_mode=this.form.p_mode;
								suborder[i].p_length=this.form.p_length;
								suborder[i].p_width=this.form.p_width;
								suborder[i].p_height=this.form.p_height;
								this.suborderscaned.push(suborder[i]);
								suborder.splice(i, 1);
								break;
							}
						}
						if (suborder.length == 0) {
							this.subscanfilish = true;
							this.CheckOrderWeight();
						}else{
							this.form.subpkval='';
							this.form.grossweight='';
							this.$refs.subpkval[0].focus();
						}
					}
					else{
						this.form.p_length=list[0].p_length;
						this.form.p_width=list[0].p_width;
						this.form.p_height=list[0].p_height;
						this.form.cgprovince=list[0].cgprovince;
						this.form.vipaccount=list[0].vipaccount;
						this.form.u_userid=list[0].u_userid;
						this.form.p_mode=list[0].p_mode;
						this.form.factpkval=list[0].p_pkval;
						this.$refs.weight[0].focus();
					}
				}
				else
					this.$refs.errorwin.init({errormsg:subpkval+that.checkweight_lang.ordernoexists,isread:true,focuscontrol:this.currentcoltrol});
			}
		},
		CheckOrderWeight(){			
			var that = this;
			var diff=0;
			var diffweight=0;
			if(that.diffweight!='')
				diffweight=Number(that.diffweight);
				
			var allweight=0;
			this.suborderscaned.forEach(e=>{
				allweight+=Number(e.grossweight);
			});
			diff=Math.abs(allweight-Number(that.form.grossweight));
			//debugger
			if(this.remind=='1'&&diff>diffweight){
				that.$refs.errorwinbtn.init({
					errormsg:that.checkweight_lang.checkweighttips+' ：'+that.form.grossweight+' '+that.checkweight_lang.pleasecheck,
					isread:true,
					focuscontrol:that.currentcoltrol});
			}
			else{
				this.suborderscaned.forEach(e=>{
					if(e.p_pkval==that.form.factpkval)
						e.grossweight=that.form.grossweight;
				});
				that.UpdateWeight();
			}
		},
		UpdateWeight(){
			var that=this;
			var paraminfo={
				pkval:this.suborderscaned[0].p_pkval,
				grossweight:this.form.grossweight,
				p_length:this.form.p_length,
				p_height:this.form.p_height,
				p_width:this.form.p_width,
				l_mode:'入库管理',
				fun:'核重',
				token:localStorage.getItem('token'),
				domain:this.$apiprototype.WebServer
			}
			this.$tool.loading(this.$lang.label.public.inoperation,this.divclass);
			this.$apipost.post.UpdateWeightSingle({paraminfo:paraminfo}).then(res => {
				if(res.state=='1')
					that.AddStorageIn();
				else{
					this.$tool.loadingclose();
					that.$refs.errorwin.init({errormsg:that.checkweight_lang[res.errorcode],isread:true});
				}
			});
		},
		AddStorageIn(){
			var that=this;
			debugger
			var paraminfo={
				orderlist:this.suborderscaned,
				batch:this.form.batch,
				u_userid: localStorage.getItem('userid'),
				u_name: localStorage.getItem('u_name'),
				u_account: localStorage.getItem('u_account'),
				u_company: localStorage.getItem('u_company')
			}
			this.$apipost.post.AddStorageIn({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.ReadMsg(that.$lang.label.public.success);
					that.orderTable.push({p_pkval:that.form.p_pkval,cgprovince:that.form.cgprovince,amount:that.form.amount,grossweight:that.form.grossweight});
					that.ScanSum();
					that.perpkval=that.form.p_pkval+'  '+that.form.cgprovince+' '+that.form.grossweight+' '+that.form.p_length+'*'+that.form.p_width+'*'+that.form.p_height;
					that.truncatepage();
				}else
					that.$refs.errorwin.init({errormsg:that.checkweight_lang.storageinfail,isread:true});
			});
		},
		closeerrorwin(e){
			if(e.isgo){
				this.suborderscaned.forEach(e=>{
					if(e.p_pkval==that.form.factpkval)
						e.grossweight=that.form.grossweight;
				});
				this.UpdateWeight();
			}else{
				if(e.focuscontrol!=undefined)
					this.$refs[e.focuscontrol][0].focus();
				if(this.issub)
					this.form.subpkval='';
				else
					this.form.p_pkval='';
				this.form.factpkval='';
			}
		},
		errorwincallback(e){
			var that=this;
			if(e.type=='sure'){
				this.suborderscaned.forEach(e=>{
					if(e.p_pkval==that.form.factpkval)
						e.grossweight=that.form.grossweight;
				});
				this.UpdateWeight();
			}else if(e.type=='cancel'){
				if(e.focuscontrol!='')
					this.$refs[e.focuscontrol][0].focus();
				if(this.issub)
					this.form.subpkval='';
				else
					this.form.p_pkval='';
				this.form.factpkval='';
			}
		},
		truncatepage(){
			this.form.p_pkval='';
			this.form.grossweight='';
			this.form.p_length='';
			this.form.p_width='';
			this.form.p_height='';
			this.form.amount=0;
			this.form.perpay=0;
			this.form.vipaccount='';
			this.form.subpkval='';
			this.form.factpkval='';
			this.form.p_mode='';
			
			this.trorder[1].isshow=0;
			this.issub=false;
			this.subscanfilish=false;
			this.suborderscaned=[];
			this.suborder=[];
			this.$refs.pkval[0].focus();
		},
		ScanSum() {
			//计算汇总
			this.scanordercount = this.orderTable.length;
			var scanorderweight = 0;//,
		 		//scanorderamount = 0.0;
			this.orderTable.forEach(e => {
				if (Number(e.grossweight)>0) scanorderweight += parseFloat(e.grossweight);
		
				//if (Number(e.amount)>0) scanorderamount +=parseFloat(e.amount);
			});
			this.scanorderweight = scanorderweight.toFixed(3);
			//this.scanorderamount = scanorderamount.toFixed(2);
		},
		SaveBatch(){
			localStorage.setItem('inbatch',this.form.batch.trim());
			var newbatch = this.form.batch;
			if (newbatch != '') {
				var that = this;
				var paraminfo = { handbatch: this.form.batch, fun: this.fun, userid: localStorage.getItem('userid') };
				this.$apipost.post
					.UpdateOutBatch({
						paraminfo: paraminfo
					})
					.then(res => {
						that.GetOrderlist();
					});
			}
		},
		GetOrderlist(){
			var that=this;
			
			this.$apipost.get
				.GetOrderlistByBatch({
					handbatch: this.form.batch,
					isin:this.isin
				})
				.then(res => {
					if(res.state=='1'){
						debugger
						res.list.forEach(e=>{
							e.grossweight=e.weight;
						});
						that.orderTable=res.list;
						that.ScanSum();
					}
				});
		},
	}
}
</script>

<style>
</style>